function CalendarIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
      <rect x="4" y="5" width="16" height="15" rx="2" stroke="currentColor" strokeWidth="1.7" />
      <path d="M4 10h16M9 3v4M15 3v4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </svg>
  );
}

/** Today in the phone's own zone, as a date input writes it. */
function today() {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, '0');

  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}

/**
 * The day the rider's licence expires, asked beside the licence: a licence is
 * its expiry (InGo ADR 0014; KangaruRide ADR-0033). Styled as the
 * registration's own fields (`driverRegisterPremium.css`). Any paper the
 * server says needs its date (the insurance too, ADR 0024) asks with its own
 * label.
 */
export default function LicenceExpiryField({ value, onChange, id = 'licence-expiry', label = 'License expires on' }) {
  return (
    <div className="dp-reg-field">
      <label className="dp-reg-label" htmlFor={id}>
        {label}
      </label>
      <div className="dp-reg-input-wrap">
        <span className="dp-reg-iconbox" aria-hidden>
          <CalendarIcon />
        </span>
        <input
          className="dp-reg-input"
          id={id}
          type="date"
          min={today()}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          required
        />
      </div>
    </div>
  );
}
